import { TaskStatus } from 'api';
import { getAITextEditorLink } from 'api/tasks/query';
import { MODALS_STORE, TASKS_MODAL_ID } from 'constants/ui/modal';
import { useLocalization } from 'localization';
import { useMemo } from 'react';

export const useAITextOverviewTaskModal = () => {
  const { t } = useLocalization();

  const { toggleModal, isModalOpen, getModalData } = MODALS_STORE.tasks();
  const taskId = getModalData(TASKS_MODAL_ID.AITextOverview)?.task?.id;
  const reference = getModalData(TASKS_MODAL_ID.AITextOverview)?.task?.caseReference;
  const taskStatus = getModalData(TASKS_MODAL_ID.AITextOverview)?.task?.status;

  const { data: aiTextEditorLink, isLoading, isFetched } = getAITextEditorLink(taskId);

  const onOpenAIText = () => {
    window.open(aiTextEditorLink, '_blank');
  };

  const descriptionMessage = useMemo(() => {
    if (taskStatus === TaskStatus.Complete) {
      return t('modals.aiText.alreadyCompleted');
    }
    return aiTextEditorLink ? t('modals.aiText.message') : t('modals.aiText.emptyMessage');
  }, [aiTextEditorLink, t, taskStatus]);

  return {
    t,
    reference,
    isLoading,
    isFetched,
    descriptionMessage,
    onOpenAIText,
    isModalOpen,
    toggleModal,
  };
};
